module.exports = __webpack_public_path__ + "static/hero-gemvisa-nz2-b78c7976c53898585bacb01c20efed94.webp";